import * as types from './types';

export const canvasChangeView = ({ commit }, panel) => {
  commit(types.CANVAS_CHANGE_VIEW, panel);
};

export const canvasChangePreviewDevice = ({ commit }, device) => {
  commit(types.CANVAS_CHANGE_PREVIEW_DEVICE, device);
};

export const canvasEnableHighlight = ({ commit }, data) => {
  commit(types.CANVAS_ENABLE_HIGHLIGHT, data.event.target);
};

export const canvasDisableHighlight = ({ commit }) => {
  commit(types.CANVAS_DISABLE_HIGHLIGHT);
};

export const canvasResetState = ({ commit }) => {
  commit(types.CANVAS_RESET_STATE);
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/canvas/actions.js
 **/